import {
  List,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";

export const IttechCustomJoins2 = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid size={5}>
          {/* Tabel 1: Games (De bronlijst) */}
          <Typography variant="h4" sx={{ mb: 2 }}>
            Tabel: Games
          </Typography>
          <Table
            size="medium"
            sx={{
              mb: 5,
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },
              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>GameID</TableCell>
                <TableCell>GameNaam</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>Fortnite</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>Minecraft</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>3</TableCell>
                <TableCell>Rocket League</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <List sx={{ fontSize: "2.2em", mt: 2 }}>
            <ListItem sx={{ fontWeight: "bold" }}>💡 De Voordelen:</ListItem>
            <ListItem>
              - Wil je een gamenaam wijzigen? Dat hoeft nu nog maar op één plek.
            </ListItem>
            <ListItem>
              - Geen kans meer op typfouten zoals "Fortnight" in je scores.
            </ListItem>
            <ListItem>
              - De database is nu "gezond" en efficiënt ingericht.
            </ListItem>
          </List>
        </Grid>

        <Grid size={7}>
          {/* Tabel 2: GameScores (De dynamische data) */}
          <Typography variant="h4" sx={{ mb: 2 }}>
            Tabel: GameScores
          </Typography>
          <Table
            size="medium"
            sx={{
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },
              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ScoreID</TableCell>
                <TableCell>Speler</TableCell>
                <TableCell sx={{ background: "#fff59d" }}>
                  GameID (FK)
                </TableCell>
                <TableCell>Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>LunaByte</TableCell>
                <TableCell sx={{ background: "#fff9c4" }}>1</TableCell>
                <TableCell>950</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>PixelPete</TableCell>
                <TableCell sx={{ background: "#fff9c4" }}>2</TableCell>
                <TableCell>870</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>3</TableCell>
                <TableCell>SkyGamer</TableCell>
                <TableCell sx={{ background: "#fff9c4" }}>1</TableCell>
                <TableCell>1030</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>4</TableCell>
                <TableCell>LunaByte</TableCell>
                <TableCell sx={{ background: "#fff9c4" }}>2</TableCell>
                <TableCell>940</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Typography variant="h5" sx={{ mt: 4, fontSize: "1.8em" }}>
            Met een <b>INNER JOIN</b> plakken we de naam uit de Games-tabel weer
            vast aan de GameID in de scores.
          </Typography>

          <Typography variant="h5">
            <LiveCodeBlock
              language="SQL"
              live={false}
              code={`SELECT GameScores.*, Games.GameNaam 
FROM GameScores
INNER JOIN Games 
ON Games.GameID = GameScores.GameID`}
            />
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
